export default {
  appUrl: window.location.origin,
  appVersion: (import.meta.env.VITE_APP_VERSION as string | undefined) ?? 'local',
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? window.location.origin + '/api',
  alias: import.meta.env.VITE_ALIAS as string | undefined,
  health: {
    ignore: window.localStorage?.getItem('health:ignore') === 'true',
  },
};
